import { createFileRoute, redirect } from "@tanstack/react-router";
import { AnalyticsDashboard } from "@/app/partner/pages/dashboard";
import { validateInsightsSearch } from "@/app/partner/pages/dashboard/PartnerInsights/state";
import { canAccessRoute } from "@/lib/auth";

export const Route = createFileRoute("/flex/dashboard/")({
	validateSearch: validateInsightsSearch,
	beforeLoad: async ({ context }) => {
		const { partner } = context;
		const access = canAccessRoute(partner, "dashboard");

		if (!access.allowed) {
			// Try to find an accessible route
			throw redirect({ to: "/flex/dashboard/leads" });
		}
	},
	component: DashboardIndex,
});

function DashboardIndex() {
	return <AnalyticsDashboard />;
}
